import axios from 'axios';
import apiConfig from '../../api.config';

export default function updateHardCheckin({ hotelId, hardCheckinValue, paperlessHardCheckinValue }) {
  const {
    host,
    URIs: { pmsUpdateHardCheckin },
  } = apiConfig;

  const uri = `${host}${pmsUpdateHardCheckin}`;

  return axios
    .put(
      uri,
      { hotelId, hardCheckinValue, paperlessHardCheckinValue },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then(res => res.data);
}
